import { defineMessages, MessageDescriptor } from 'react-intl'

export const NEURODIVERSITY_ESSENTIALS_TITLES = defineMessages({
  LEARN_ABOUT_NEURODIVERSITY: {
    defaultMessage: 'Learn about neurodiversity',
    description: 'Title for section with resources to learn about neurodiversity',
  },
  LIVING_WITH_NEURODIVERSITY: {
    defaultMessage: 'Living with neurodiversity',
    description: 'Title for section with resources for living with neurodiversity',
  },
  WORKING_WITH_NEURODIVERSITY: {
    defaultMessage: 'Working with neurodiversity',
    description: 'Title for section with resources for working with neurodiversity',
  },
  ROLES_AND_RELATIONSHIPS: {
    defaultMessage: 'Roles and relationships',
    description: 'Title for section with resources for roles and relationships',
  },
})

export const neurodiversityEssentialsContent: { title: MessageDescriptor; articleIds: number[] }[] = [
  {
    title: NEURODIVERSITY_ESSENTIALS_TITLES.LEARN_ABOUT_NEURODIVERSITY,
    articleIds: [2508052, 2508145, 2368503],
  },
  {
    title: NEURODIVERSITY_ESSENTIALS_TITLES.LIVING_WITH_NEURODIVERSITY,
    articleIds: [2512583, 2563142, 2563154, 2126270],
  },
  {
    title: NEURODIVERSITY_ESSENTIALS_TITLES.WORKING_WITH_NEURODIVERSITY,
    articleIds: [2563157, 2563139, 2563151],
  },
  {
    title: NEURODIVERSITY_ESSENTIALS_TITLES.ROLES_AND_RELATIONSHIPS,
    articleIds: [2563148, 2563145, 2563161],
  },
]
